{
  "login": {
    "title": "Sign in to the platform",
    "subtitle": "Accounts are issued by the organization administrator.",
    "email": "Email",
    "password": "Password",
    "checking": "Checking…",
    "submit": "Sign in",
    "resetHint": "Password resets go through your administrator",
    "demoHint": "demo diagram · objects can be dragged with the mouse",
    "noConnection": "No connection to the server. Check your network and try again.",
    "tooManyAttempts": "Too many sign-in attempts. {{hint}}",
    "retryInSeconds": "Try again in {{seconds}} s.",
    "retryInAMinute": "Try again in a minute.",
    "badCredentials": "Wrong email or password."
  },
  "change": {
    "title": "Change your password",
    "subtitle": "You signed in with a temporary password issued by an administrator. You are not the only one who knows it — set your own.",
    "temporary": "Temporary password",
    "newPassword": "New password",
    "repeat": "New password again",
    "tooShort": "At least {{min}} characters",
    "minLength": "at least {{min}} characters",
    "mismatch": "The passwords do not match",
    "saving": "Saving…",
    "submit": "Change password",
    "sessionsNote": "All sessions end after the change — you will need to sign in again."
  },
  "demo": {
    "label": "Demo diagram of a site network",
    "site": "Head office",
    "node": {
      "gateway": "Gateway",
      "core": "SW-1 · core",
      "server": "App server",
      "pos": "POS-1",
      "camera": "Camera · entrance"
    },
    "hint": {
      "icmp2ms": "icmp 2 ms",
      "snmp18": "snmp · 18 ports",
      "noChecks": "no checks",
      "tcpSilent": "tcp:5900 no answer",
      "icmpDown": "icmp down 4 min"
    }
  }
}
